/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { SelectProps, Select, MenuItem, InputLabel } from "@mui/material";
import { forwardRef } from "react";
import { SelectArrayType } from "types/form.enum";

/**
 * Props for CustomSelect component.
 * @interface CustomSelectProps
 * @extends {SelectProps}
 * @property {SelectArrayType[]} selectArray - Array of options with value and label
 * @property {string} value - Currently selected value
 */
export interface CustomSelectProps extends SelectProps {
  selectArray: SelectArrayType[];
  value: string;
}

/**
 * Custom select dropdown with standard variant styling.
 * 
 * Features:
 * - Standard Material-UI variant
 * - Custom line height (1.8rem)
 * - Option array mapping
 * - Default value support
 * - Forward ref support
 * 
 * @param selectArray - Array of {value, label} options
 * @param label - Select field label
 * @param value - Default selected value
 * @param rest - Additional SelectProps
 * @returns Styled select dropdown
 */
const CustomSelect = forwardRef(
  ({ selectArray, label, value, ...rest }: CustomSelectProps, ref) => {
    return (
      <Select
        variant="standard"
        className="select-container"
        defaultValue={value}
        {...rest}
        ref={ref}
      >
        {selectArray.map((value, index) => (
          <MenuItem key={`${label}Definition${index}`} value={value.value}>
            {value.label}
          </MenuItem>
        ))}
      </Select>
    );
  }
);

export default CustomSelect;
